module.exports = __webpack_public_path__ + "img/20191028172329839.8087c46e.jpg";